exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_gettingStated_1OsABcE6lKRwbGkP2_MBMm {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_video_1zybBWcSxA22SdzRhS38iH {\n  position: relative;\n  float: left;\n  width: 300px;\n  height: 169px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_gettingStated": "IA_gettingStated_1OsABcE6lKRwbGkP2_MBMm",
	"IA_video": "IA_video_1zybBWcSxA22SdzRhS38iH"
};